import { css } from '@emotion/react';
import { colors } from '../../../../../theme/colors';
import { DropZone } from '../types';

const overlayContainerStyle = css`
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 10;
`;

const activeZoneStyle = css`
  position: absolute;
  background: ${colors.primary[10]};
  border: 2px dashed ${colors.primary[40]};
  transition:
    top 0.15s ease,
    left 0.15s ease,
    width 0.15s ease,
    height 0.15s ease,
    opacity 0.15s ease;
`;

interface DropZoneOverlayProps {
  activeZone: DropZone | null;
}

// Get the style for the active zone based on its position
function getZonePositionStyle(zone: DropZone | null) {
  switch (zone) {
    case 'top':
      return css`
        top: 0;
        left: 0;
        width: 100%;
        height: 50%;
        opacity: 1;
      `;
    case 'bottom':
      return css`
        top: 50%;
        left: 0;
        width: 100%;
        height: 50%;
        opacity: 1;
      `;
    case 'left':
      return css`
        top: 0;
        left: 0;
        width: 50%;
        height: 100%;
        opacity: 1;
      `;
    case 'right':
      return css`
        top: 0;
        left: 50%;
        width: 50%;
        height: 100%;
        opacity: 1;
      `;
    default:
      return css`
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      `;
  }
}

export function DropZoneOverlay({ activeZone }: DropZoneOverlayProps) {
  return (
    <div css={overlayContainerStyle}>
      <div css={[activeZoneStyle, getZonePositionStyle(activeZone)]} />
    </div>
  );
}
